const APP_SESSION_HINT_COOKIE = "pp_app_session_hint";

export function hasAppSessionHint(): boolean {
  try {
    const cookieHeader = document.cookie;
    return cookieHeader.split(";").some((entry) => {
      const separator = entry.indexOf("=");
      if (separator < 0) return false;
      return entry.slice(0, separator).trim() === APP_SESSION_HINT_COOKIE
        && entry.slice(separator + 1) === "v1";
    });
  } catch {
    return false;
  }
}
